module.exports = __webpack_public_path__ + "img/bohrungen-4.c94f087a.png";